<template>
  <div style="height: 100%">
    <el-container style="height: 100%">
      <el-header height="70px">
        <header-area :train="trainHistory"></header-area>
      </el-header>
      <el-main>
        <question :question="questions[current]" @nextQuestion="(q)=>nextQuestion(q)"></question>
      </el-main>
      <el-footer height="60px">
        <footer-area :current="current" :total="questions.length"></footer-area>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { mapGetters,mapMutations } from 'vuex'
import Question from './components/question'
import Header from './components/header'
import Footer from './components/footer'

export default {
  data() {
    return {
      baseApi: '/train',
      questionCount: '',
      words: [],
      questions: [],
      current: 0,
      trainHistory: {
        name: null,
        score: 0,
        totalCount: 0,
        trueCount: 0,
        useTime:'--:--',
        //读音写
        type: null,
        accountId: null,
      },
      reviewOver: {}
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  components: {
    'question': Question,
    'header-area': Header,
    'footer-area': Footer,
  },
  created() {
    this.trainHistory.name = this.$route.params.name;
    this.trainHistory.type = this.$route.params.type;
    this.questionCount = this.$route.params.questionCount;
    this.trainHistory.accountId = this.info.id;

    this.findWords(this.$route.params.words,this.$route.params.questionCount);
    this.reviewOver = this.$route.params.reviewOver
  },
  methods: {
    ...mapMutations([
      'setInfo'
    ]),
    findWords(wordIds, count) {
      this.$fly.post(`${this.baseApi}/question-words/${count}`,{'wordIds':wordIds}).then((res)=>{
        this.words = res;
        this.trainHistory.totalCount = this.words.length;
        if(this.trainHistory.name.indexOf('课后练习') != -1) {
          this.addScore((Math.ceil(this.words.length/5))*3,'学习',0,this.trainHistory.name)
        }
        this.createQuestion(this.words)
      })
    },
    createQuestion(words) {
      let questions = [];
      for (let i = 0; i < words.length; i++) {
        let word = words[i];
        let question;
        let qType;

        if (this.trainHistory.type == 4) {
          qType = Math.floor(Math.random()*3+1);
          
        } else {
          qType = this.trainHistory.type;
        }

        if (qType == 1 || qType == 2) {
          let a = this.getOption(words,[i]);
          let b = this.getOption(words,[i,a]);
          let c = this.getOption(words,[i,a,b]);
          let d = this.getOption(words,[i,a,b,c]);
          
          question = {
            'optionA': words[a].content3,
            'optionB': words[b].content3,
            'optionC': words[c].content3,
            'optionD': words[d].content3,
            'answer': '',
            'questionWordId': word.wordNo,
            'questionWord': word,
            'type': qType,
          }

          let t = Math.floor(Math.random()*4+1);
          switch (t) {
            case 1:
              question.optionA = question.questionWord.content3
              break;
            case 2:
              question.optionB = question.questionWord.content3
              break;
            case 3:
              question.optionC = question.questionWord.content3
              break;
            default:
              question.optionD = question.questionWord.content3
              break;
          }
        } else if (qType == 3) {
          question = {
            'optionA': '',
            'optionB': '',
            'optionC': '',
            'optionD': '',
            'answer': '',
            'questionWordId': word.wordNo,
            'questionWord': word,
            'type': qType,
          }
        }

        questions.push(question);
      }
      this.questions = questions;
    },
    getOption(words,notIn) {
      let max = words.length;
      let i = Math.floor(Math.random()*max);
      if (notIn.indexOf(i) == -1) {
        return i;
      } else {
        return this.getOption(words,notIn);
      }
    },
    nextQuestion(q) {
      this.questions[this.current] = q;
      if (this.current<this.questions.length-1) {
        this.current++;
      } else {
        let trueWords = [];
        for (let i = 0; i < this.questions.length; i++) {
          const q = this.questions[i];
          if (q.type == 3) {
            if (q.answer.trim().toLowerCase() == q.questionWord.content1.trim().toLowerCase()) {
              this.trainHistory.trueCount++;
              trueWords.push(q.questionWord.wordNo)
            }
          } else {
            if (q.answer == q.questionWord.content3) {
              this.trainHistory.trueCount++;
              trueWords.push(q.questionWord.wordNo)
            }
          }
          q.questionWordId = q.questionWord.wordNo
        }
        this.trainHistory.score = Math.floor((this.trainHistory.trueCount/this.trainHistory.totalCount)*100);
        

        if(this.trainHistory.name.indexOf('每日复习') != -1) {
          this.$fly.post(`${this.baseApi}/update-word`,{
            'wordIds': trueWords,
            'studentAccountId.eLong': this.info.id
          }).then(()=>{
            this.addScore(this.trainHistory.score*2,'复习',0,this.trainHistory.name)
            this.$router.push({
              name: '学习',
              params: this.reviewOver
            })
            
          })
        } else {
          this.$fly.post(`${this.baseApi}/save-train`,{
            'train': this.trainHistory,
            'questions': this.questions
          }).then(()=>{
            this.$alert(`本次练习正确题数(${this.trainHistory.trueCount}/${this.trainHistory.totalCount}),最终得分${this.trainHistory.score},再接再厉哦!`, '练习完成', {
              confirmButtonText: '返回首页',
              callback: () => {
                this.$router.push('/');
                if(this.trainHistory.name.indexOf('课后练习') != -1) {
                  this.addScore((Math.ceil(this.trainHistory.score/20))*6,'练习',this.trainHistory.totalCount,this.trainHistory.name)
                }
              }
            });
          })
        }
      }
    },
    addScore(score,type,wordCount,trainName) {
      this.$fly.post(`${this.baseApi}/add-score`,{
        "id": this.info.id,
        "score": score
      }).then(()=> {
        this.$fly.post(`${this.baseApi}/update-day-history`,{
          "studentAccountId.eLong": this.info.id,
          "rank": score,
          "wordCount": wordCount,
          "trainName": trainName,
        }).then(()=>{
          this.info.rank+=score
          this.setInfo(this.info)
          this.$message({
            message: `${type}完成,获得积分 +${score}`,
            type: 'success'
          });
        })
      })
    }
  }
}
</script>
<style scoped>
.el-header, .el-footer {
  background-color: #334970ee;
  color: #fff;
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e7eef8;
  color: #333;
  text-align: center;
  height: calc(100vh - 130px);
}
.foot-area{
  font-size: 1.3em
}
</style>